import { FC } from 'react';
import { Button, Icon } from 'common-components';
import { InformationDialogProps } from './informationDialogTypes';
import styles from './informationDialog.module.scss';
import Avatar from '../../avatar/avatar';
import Tooltip from '../../tooltip';
import RadialProgress from '../radialProgress/radialProgress';

const InformationDialog: FC<InformationDialogProps> = props => {
    const { title, icon, subTitle, content, confirmation, actions, useWrapper, maxAvatars = 4, wrapperRef } = props;

    const tooltipContent = () => (
        <div className={styles['tooltip-container']}>
            <span className={styles.title}>{content.tooltipContent}</span>
            {content.users && (
                <ol className={styles.content}>
                    {content.users.slice(maxAvatars, content.users.length).map((user, index) => (
                        <li key={index}>{user.nickname}</li>
                    ))}
                </ol>
            )}
        </div>
    );

    return (
        <div className={useWrapper ? styles['background-wrapper'] : undefined} ref={wrapperRef}>
            <div className={styles.wrapper}>
                <div className={styles['top-wrapper']}>
                    <div className={styles.top}>
                        <Icon name={icon} className={styles.icon} />
                        <div className={styles.title}>{title}</div>
                        <hr />
                        <div className={styles['sub-text']}>{subTitle}</div>
                    </div>
                </div>
                <div className={styles.body}>
                    {content && (
                        <div className={styles.content}>
                            <div className={styles.summary}>{content.summary}</div>
                            {content.users && content.users.length > 0 && (
                                <div className={styles['users-wrapper']}>
                                    {content.users.slice(0, maxAvatars).map((user: any, index) => (
                                        <div key={index} style={{ position: 'relative' }}>
                                            <Avatar name={user.nickname} avatarSrc={user.profilePicture}></Avatar>
                                            {user.progress && (
                                                <RadialProgress
                                                    percentage={user.progress}
                                                    radius={2.5}
                                                    containerCx={styles['radial-progress']}
                                                    color={'#CBB8FA'}
                                                    bgColor={'transparent'}
                                                    innerRadius={0.9}
                                                />
                                            )}
                                        </div>
                                    ))}
                                    {content.users.length > maxAvatars && (
                                        <div className={styles['plus-users']}>
                                            <Tooltip
                                                type="secondary"
                                                title={tooltipContent() || ''}
                                                placement={'right-start'}
                                            >
                                                <span>+{content.users.length - maxAvatars}</span>
                                            </Tooltip>
                                        </div>
                                    )}
                                </div>
                            )}
                            {content.description && <div className={styles.description}>{content.description}</div>}
                        </div>
                    )}
                </div>
                <div className={styles.divider}></div>
                <div className={styles.summary}>
                    <div className={styles.text}>{confirmation}</div>
                    <div className={styles['buttons-wrapper']}>
                        {actions &&
                            actions.map((action: any, index) => (
                                <Button
                                    key={index}
                                    onClick={action.isEnabled ? () => action.onClick() : undefined}
                                    type={action.class}
                                    lowerCase={true}
                                    text={action.label}
                                />
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InformationDialog;
